export enum PAGES {
  /**
   * 首页
   */
  HOME = "/",
  /**
   * 登录
   */
  USER_LOGIN = "/user/login",
  /**
   * 开放平台授权
   */
  CONNECT = "/connect",
  /**
   * 商品列表
   */
  GOODS_LIST = "/goods/list",
  /**
   * 商品发布
   */
  GOODS_CREATE = "/goods/create",
  /**
   * 商品编辑
   */
  GOODS_DETAIL = "/goods/detail",
  /**
   * 商品素材
   */
  GOODS_MATERIAL = "/goods/material",
  /**
   * 商品缺图预警
   */
  GOODS_MISSING_WARNING = "/goods/missing-warning",
  /**
   * 商品成长
   */
  GOODS_GROW = "/goods/grow",
  /**
   * 前置仓计划页
   */
  PRE_STORE_PLAN = "/pre-store/plan",
  /**
   * 前置仓计划创建页
   */
  PRE_STORE_PLAN_CREATE = "/pre-store/plan/create",
  /**
   * 前置仓计划详情页
   */
  PRE_STORE_PLAN_DETAIL = "/pre-store/plan/detail",
  /**
   * 前置仓邀约池
   */
  PRE_STORE_INVITATION = "/pre-store/invitation",
  /**
   * 前置仓邀约池创建页
   */
  PRE_STORE_INVITATION_CREATE = "/pre-store/invitation/create",
  /**
   * 前置仓库存
   */
  PRE_STORE_STOCK = "/pre-store/stock",
  /**
   * 前置仓出入库日志
   */
  PRE_STORE_STOCK_MOVEMENT = "/pre-store/stock-movement",
  /**
   * 前置仓报表
   */
  PRE_STORE_REPORT = "/pre-store/report",
  /**
   * 前置仓报表详情页
   */
  PRE_STORE_REPORT_DETAIL = "/pre-store/report/detail",
  /**
   * 前置仓报表详情页
   */
  PRE_STORE_REPORT_BALANCE_DETAIL = "/pre-store/report/balance/detail",
  /**
   * 前置仓报表详情页
   */
  PRE_STORE_REPORT_PLAN_DETAIL = "/pre-store/report/plan/detail",
  /**
   * 前置仓报表详情页
   */
  PRE_STORE_REPORT_NO_DATA_DETAIL = "/pre-store/report/no-data/detail",
  /**
   * 前置仓报表详情页
   */
  PRE_STORE_REPORT_STOCK_OUT_DETAIL = "/pre-store/report/stock-out/detail",
  /**
   * 前置仓退供列表 */
  PRE_STORE_REPORT_RETURN_DETAIL = "/pre-store/report/return/detail",
  /**
   * 前置仓退供列表
   **/
  PRE_STORE_REPORT_BILL_DETAIL = "/pre-store/report/bill/detail",
  /**
   * 前置仓退供列表
   */
  PRE_STORE_REFUND = "/pre-store/refund",
  /**
   * 前置仓退供创建页
   */
  PRE_STORE_REFUND_CREATE = "/pre-store/refund/create",
  /**
   * 前置仓退供详情页
   */
  PRE_STORE_REFUND_DETAIL = "/pre-store/refund/detail",
  /**
   * 店铺装修
   */
  MARKET_DECORATE = "/market/decorate",
  /**
   * 主推新款
   */
  MARKET_DECORATE_MAIN_NEW = "/market/decorate/main-new",
  /**
   * 小妹爆款推荐
   */
  MARKET_DECORATE_HOT_SELL = "/market/decorate/hot-sell",
  /**
   * 商品置顶
   */
  MARKET_DECORATE_GOODS_TOP = "/market/decorate/goods-top",
  /**
   * 镇店之宝
   */
  MARKET_DECORATE_TREASURE = "/market/decorate/treasure",
  /**
   * 红包
   */
  MARKET_PACKET = "/market/packet",
  /**
   * 创建红包
   */
  MARKET_PACKET_CREATE = "/market/packet/create",
  /**
   * 活动广场
   */
  MARKET_PLAZA = "/market/plaza",
  /**
   * 满减
   */
  MARKET_DISCOUNT = "/market/discount",
  /**
   * 创建满减
   */
  MARKET_DISCOUNT_CREATE = "/market/discount/create",
  /**
   * 特价
   */
  MARKET_SPECIAL_PRICE = "/market/special-price",
  /**
   * 创建特价
   */
  MARKET_SPECIAL_PRICE_CREATE = "/market/special-price/create",
  /**
   * 秒杀
   */
  MARKET_FLASH_SALE = "/market/flash-sale",
  /**
   * 创建秒杀
   */
  MARKET_FLASH_SALE_CREATE = "/market/flash-sale/create",
  /**
   * 秒杀详情
   */
  MARKET_FLASH_SALE_DETAIL = "/market/flash-sale/detail",
  /**
   * 订货单
   */
  ORDER_SHEET = "/order/sheet",
  /**
   * 订货单开单
   */
  ORDER_SHEET_CREATE = "/order/sheet/create",
  /**
   *  订货单断货
   */
  ORDER_SHEET_OUT_OF_STOCK = "/order/sheet/out-of-stock",
  /**
   * 订货单-一条订单流开单
   */
  ORDER_SHEET_UNIFIED_CREATE = "/order/sheet/unified-create",
  /**
   * 订单
   */
  ORDER_SALES = "/order/sales",
  /**
   *  订单详情
   */
  ORDER_SALES_DETAIL = "/order/sales/detail",
  /**
   * 一条订单流订单详情
   */
  ORDER_SALES_UNIFIED_DETAIL = "/order/sales/unified-detail",
  /**
   * 欠货明细
   */
  ORDER_OWED_GOODS = "/order/owed-goods",

  /**
   *  活动费清单
   */
  ORDER_FEE_ACTIVITY = "/order/fee-activity",
  /**
   *  活动费清单详情
   */
  ORDER_FEE_ACTIVITY_DETAIL = "/order/fee-activity/detail",
  /**
   * 发货单
   */
  ORDER_SHIPPING_ORDER = "/order/shipping-order",
  /**
   * 店铺直播
   */
  LIVE_SHOP_LIVE = "/live/shopLive",
  /**
   * 直播数据
   */
  LIVE_LIVE_DATA = "/live/liveData",
  /**
   * 银行卡管理
   */
  CAPITAL_BANK_CARD = "/capital/bank-card",
  /**
   * 银行账户添加页
   */
  CAPITAL_BANK_CARD_CREATE = "/capital/bank-card/create",
  /**
   * 银行账户鉴权
   */
  CAPITAL_BANK_CARD_SIGN = "/capital/bank-card/sign",
  /**
   * 更改合同签署信息
   */
  CAPITAL_CONTRACT_INFO_CHANGE = "/capital/contract-info-change",
  /**
   * 账号管理
   */
  PERSONAL_ACCOUNT = "/personal/account",
  /**
   * 资金账户
   */
  CAPITAL_ACCOUNT = "/capital/account",
  /**
   * 账号权限
   */
  SUB_ACCOUNT_PERMISSION_PATH = "/shop/sub-account/permission",
  /**
   * 新增岗位
   */
  SUB_ACCOUNT_POSITION_CREATE = "/shop/sub-account/position/create",
  /**
   * 编辑岗位
   */
  SUB_ACCOUNT_POSITION_EDIT = "/shop/sub-account/position/edit",
  /**
   * 查看岗位
   */
  SUB_ACCOUNT_POSITION_VIEW = "/shop/sub-account/position/view",
  /**
   * 子账号管理
   */
  SUB_ACCOUNT_MANAGE = "/shop/sub-account",
  /**
   * 商家成长中心
   */
  SHOP_GROWN = "/shop/grown",
  /**
   * 店铺数据导出
   */
  SHOP_DATA_EXPORT = "/shop/data-export",
  /**
   * 店铺账单导出
   */
  SHOP_BILL_EXPORT = "/shop/bill-export",
  /**
   * 经营概览
   */
  DATA_OVERVIEW = "/data/overview",
  /**
   * 直播数据
   */
  LIVE_DATA_DETAIL = "/live/liveDataDetail",
  /**
   * 交易数据
   */
  DATA_TRADE = "/data/trade",
  /**
   * 商品数据
   */
  DATA_GOODS = "/data/goods",
  /**
   * 流量数据
   */
  DATA_FLOW = "/data/flow",
  /**
   * 履约数据
   */
  DATA_PERFORMANCE = "/data/performance",
  /**
   * 人群管理
   **/
  MEMBER_SEGMENTATION = "/member/segmentation",
  /**
   * 创建人群
   */
  MEMBER_SEGMENTATION_CREATE = "/member/segmentation/create",
  /**
   * 编辑人群
   */
  MEMBER_SEGMENTATION_EDIT = "/member/segmentation/edit",
  /**
   * 用户画像
   */
  MEMBER_PORTRAIT = "/member/portrait",
  /**
   * 充值
   */
  CAPITAL_ADD_MONEY = "/capital/add-money",
  /**
   * 短信营销
   */
  MEMBER_MESSAGE = "/member/message",
  /**
   * 短信购买
   */
  MEMBER_MESSAGE_PURCHASE = "/member/message/purchase",
  /**
   * 购买记录
   */
  MEMBER_MESSAGE_PURCHASE_RECORD = "/member/message/purchase-record",
  /**
   * 短信账单
   */
  MEMBER_MESSAGE_BILL = "/member/message/bill",
  /**
   * 短信计划-创建
   */
  MEMBER_MESSAGE_PLAN_CREATE = "/member/message/plan/create",
  /**
   * 短信计划-编辑
   */
  MEMBER_MESSAGE_PLAN_EDIT = "/member/message/plan/edit",
}

/**
 * 埋点页面名称映射
 */
export const TRACKER_ROUTE_NAME = {
  [PAGES.GOODS_LIST]: "商品管理",
  [PAGES.GOODS_CREATE]: "商品发布",
  [PAGES.GOODS_DETAIL]: "商品编辑",
  [PAGES.GOODS_MATERIAL]: "商品素材",
  [PAGES.GOODS_GROW]: "商品成长",
  [PAGES.PRE_STORE_PLAN]: "前置仓计划列表",
  [PAGES.PRE_STORE_INVITATION]: "前置仓邀约池",
  [PAGES.PRE_STORE_STOCK]: "前置仓库存",
  [PAGES.PRE_STORE_STOCK_MOVEMENT]: "前置仓出入库日志",
  [PAGES.PRE_STORE_REFUND]: "前置仓退供列表",
  [PAGES.PRE_STORE_REPORT]: "前置仓报表",
  [PAGES.ORDER_SHEET]: "订货单",
  [PAGES.ORDER_SHEET_CREATE]: "订货单开单",
  [PAGES.ORDER_SHEET_OUT_OF_STOCK]: "订货单断货",
  [PAGES.ORDER_SALES]: "销售订单",
  [PAGES.ORDER_SALES_DETAIL]: "销售订单详情",
  [PAGES.ORDER_OWED_GOODS]: "欠货明细",
  [PAGES.ORDER_FEE_ACTIVITY]: "活动费清单",
  [PAGES.ORDER_FEE_ACTIVITY_DETAIL]: "活动费清单详情",
  [PAGES.ORDER_SHIPPING_ORDER]: "发货单",
  [PAGES.LIVE_SHOP_LIVE]: "店铺直播",
  [PAGES.LIVE_LIVE_DATA]: "直播数据",
  [PAGES.SUB_ACCOUNT_MANAGE]: "子账号管理",
  [PAGES.SHOP_GROWN]: "商家成长中心",
  [PAGES.SHOP_DATA_EXPORT]: "店铺数据导出",
  [PAGES.SHOP_BILL_EXPORT]: "店铺账单导出",
  [PAGES.DATA_OVERVIEW]: "经营概览",
  [PAGES.LIVE_DATA_DETAIL]: "直播数据详情",
  [PAGES.MARKET_DECORATE]: "店铺装修",
  [PAGES.MARKET_DECORATE_MAIN_NEW]: "主推新款",
  [PAGES.MARKET_DECORATE_HOT_SELL]: "小妹爆款推荐",
  [PAGES.MARKET_DECORATE_GOODS_TOP]: "商品置顶",
  [PAGES.MARKET_DECORATE_TREASURE]: "镇店之宝",
  [PAGES.MARKET_PACKET]: "红包",
  [PAGES.MARKET_PACKET_CREATE]: "创建红包",
  [PAGES.MARKET_PLAZA]: "活动广场",
  [PAGES.MARKET_DISCOUNT]: "满减",
  [PAGES.MARKET_DISCOUNT_CREATE]: "创建满减",
  [PAGES.MARKET_SPECIAL_PRICE]: "特价",
  [PAGES.MARKET_SPECIAL_PRICE_CREATE]: "创建特价",
  [PAGES.MARKET_FLASH_SALE]: "秒杀",
  [PAGES.MARKET_FLASH_SALE_CREATE]: "创建秒杀",
  [PAGES.MARKET_FLASH_SALE_DETAIL]: "秒杀详情",
  [PAGES.CAPITAL_BANK_CARD]: "银行卡管理",
  [PAGES.CAPITAL_BANK_CARD_CREATE]: "添加银行卡",
  [PAGES.CAPITAL_CONTRACT_INFO_CHANGE]: "更改合同签署信息",
  [PAGES.PERSONAL_ACCOUNT]: "账号管理",
  [PAGES.CAPITAL_ACCOUNT]: "资金账户",
  [PAGES.DATA_TRADE]: "交易数据",
  [PAGES.DATA_GOODS]: "商品数据",
  [PAGES.DATA_FLOW]: "流量数据",
  [PAGES.MEMBER_SEGMENTATION]: "人群管理",
  [PAGES.MEMBER_SEGMENTATION_CREATE]: "创建人群",
  [PAGES.MEMBER_SEGMENTATION_EDIT]: "编辑人群",
  [PAGES.MEMBER_PORTRAIT]: "用户画像",
  [PAGES.CAPITAL_ADD_MONEY]: "充值",
  [PAGES.MEMBER_MESSAGE]: "短信营销",
  [PAGES.MEMBER_MESSAGE_PURCHASE]: "短信购买",
  [PAGES.MEMBER_MESSAGE_PURCHASE_RECORD]: "购买记录",
  [PAGES.MEMBER_MESSAGE_BILL]: "短信账单",
  [PAGES.MEMBER_MESSAGE_PLAN_CREATE]: "短信账单",
  [PAGES.MEMBER_MESSAGE_PLAN_EDIT]: "短信账单",
  [PAGES.GOODS_MISSING_WARNING]: "商品缺图预警",
};
